import React, { Component } from 'react';
import { asyncConnect } from 'react-async-client';
import { path } from 'ramda';
import { Button } from 'antd';
import Translate from 'react-translate-component';

import { getScript } from 'actions/asyncActions';
import { openModalEventScript } from 'actions/modalActions';
import SpinCenter from 'components/common/SpinCenter';
import ErrorHTML from 'components/common/form/ErrorHTML';

@asyncConnect({
    getScript: getScript
        .withPayload(path(['event', 'id']))
        .withOptions({ dispatchOnMount: true, autoReset: true })
}, null, {
    openModalEventScript,
})
export default class ScriptForm extends Component {
    save = script => {
        const { getScript: { data: { id } }, save } = this.props;
        const result = {
            fileType: 'script',
            script,
            id
        };

        save(result);
    }

    render () {
        const { getScript: { meta, data }, event, openModalEventScript } = this.props;

        const minlength = path(['result', 'minSymbols'], event);
        const body = path(['preview', 'body'], data);

        return (
            <div className="script-form">
                <div className="text-center">
                    { meta.success && (
                        <Button
                            className='card-button'
                            type='primary'
                            onClick={() => openModalEventScript({
                                body,
                                options: {
                                    minlength
                                },
                                onComplete: this.save,
                            })}
                        >
                            <Translate content="events.formDocumentResult" />
                        </Button>
                    )}
                    { meta.pending && <SpinCenter /> }
                    { meta.error && <ErrorHTML meta={meta} /> }
                </div>
            </div>
        );
    }
}
